module.exports = __webpack_public_path__ + "static/media/robot_icon.7d9d4cfe.svg";